const settings = {
  cookieAuthToken: "auth_token",
  APIHost: "https://ps2.igamesapi.dev/api",
  //APIHost: "http://localhost:3450/api",
  socketHost: "https://sio.igamesapi.dev",
  //socketHost: "http://localhost:3460",
  APIRoutes: {
    login: () => settings.APIHost + "/panel/login",
    auth: () => settings.APIHost + "/panel/manager/auth",
    getCategories: () => settings.APIHost + "/app/categories",
    uploadImages: () => settings.APIHost + "/panel/manager/upload-image",
    addCategory: () => settings.APIHost + "/panel/manager/add-category",
    saveGame: () => settings.APIHost + "/panel/manager/save-game",
    getGames: () => settings.APIHost + "/panel/manager/games",
    searchGames: () => settings.APIHost + "/panel/manager/search",
    saveHighlights: () => settings.APIHost + "/panel/manager/save-highlights",
    updateCat: () => settings.APIHost + "/panel/manager/update-category",
    deleteCat: () => settings.APIHost + "/panel/manager/delete-category",
    saveConfigs: () => settings.APIHost + "/panel/manager/save-configs",
    getConfigs: () => settings.APIHost + "/panel/manager/configs",
    deleteGame: () => settings.APIHost + "/panel/manager/delete-game",
    getUsersStatistics: () =>
      settings.APIHost + "/panel/manager/users-status-statistics",
    getUsersStatus: () => settings.APIHost + "/app/users-status",
    getNotifiable: () => settings.APIHost + "/panel/manager/get-notifiable",
    getSearches: () => settings.APIHost + "/panel/manager/searches-in-app",
    getReviews: () => settings.APIHost + "/panel/manager/last-reviews",
    getSaves: () => settings.APIHost + "/panel/manager/game-saves",
    addSave: () => settings.APIHost + "/panel/manager/add-game-save",
    deleteSave: () => settings.APIHost + "/panel/manager/delete-game-save",
    deleteSaveLink: () =>
      settings.APIHost + "/panel/manager/delete-game-save-link",
    getPlayingGames: () => settings.APIHost + "/panel/manager/playing-games",
    getNotificationsInfo: () => settings.APIHost + "/messaging/notifications",
    getRepack: () => settings.APIHost + "/panel/manager/repack",
    setRepack: () => settings.APIHost + "/panel/manager/set-repack",
    getRepackLogs: () => settings.APIHost + "/panel/manager/repack-logs",
    // Temporadas / prêmios do rank (painel, JWT) — mesmas rotas do painel PSX.
    getSeasons: () => settings.APIHost + "/panel/user/seasons",
    createSeason: () => settings.APIHost + "/panel/user/season",
    seasonPrizes: (id) =>
      settings.APIHost + "/panel/user/season/" + id + "/prizes",
    seasonRanking: (id) =>
      settings.APIHost + "/panel/user/season/" + id + "/ranking",
    saveSeasonPrize: (id) =>
      settings.APIHost + "/panel/user/season/" + id + "/prize",
    finalizeSeason: (id) =>
      settings.APIHost + "/panel/user/season/" + id + "/finalize",
    redeliverPrize: (id, position) =>
      settings.APIHost +
      "/panel/user/season/" +
      id +
      "/prize/" +
      position +
      "/redeliver",
    rewardsSettings: () => settings.APIHost + "/panel/user/rewards-settings",
    giftCardStockSummary: () =>
      settings.APIHost + "/panel/user/gift-card-stock/summary",
    addGiftCardStock: () => settings.APIHost + "/panel/user/gift-card-stock",
  },
};

export default settings;
